<template>
    <a-modal 
             :loading="isLoading"
             :visible="isVisible"
             :closable="false"
             width="300px"
    >
        <template slot="footer">
            <a-button type="primary" @click="handleOK">
                OK
            </a-button>
        </template>
        <a-row type="flex" justify="start" class="icons-list">
             <a-col :flex="2">
                <a-icon :type="icon" />
            </a-col>
            <a-col :flex="2">
                <h5> {{ message }}</h5>
            </a-col>
        </a-row>

        <a-row type="flex" justify="start" class="icons-list">
            <a-col :flex="2">
                <p> Please check your internet connection and refresh the app!</p>
            </a-col>
        </a-row>

    </a-modal>
</template>

<script>
export default {
    props : {
        isVisible : Boolean,
        message : String
    },
    data() {
        return {
            icon : 'loading',
            isLoading : false,
        }
    },
    methods : {

        handleOK() {
            location.reload();
        },
        
    },
    created() {
        this.isVisible = false;
    }
}
</script>

<style scoped>
</style>